import { styled } from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';
import TableCellMui from '@mui/material/TableCell';
import MenuMui, { MenuProps } from '@mui/material/Menu';
import MenuItemMui from '@mui/material/MenuItem';

export const Container = styled('div')({
  margin: '20px 0'
});

export const Buttons = styled('div')({
  whiteSpace: 'nowrap',
  button: {
    marginRight: 26,
    color: '#0675DD',
    '&:last-child': {
      marginRight: 0
    }
  }
});

export const ActionButtons = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minWidth: 130,
  columnGap: 16,
  '& .MuiLink-root': {
    color: '#0675DD'
  }
});

export const RightAlignedActionButtons = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  '& .MuiLink-root': {
    color: '#0675DD'
  }
});

export const RightAlignedActionCell = styled(TableCellMui)({
  width: 0,
  textAlign: 'right'
});

export const Separator = styled('div')({
  width: 1,
  height: 20,
  marginRight: 16,
  display: 'inline-block',
  marginBottom: -6,
  backgroundColor: '#E9EAEE'
});

export const Menu = styled((props: MenuProps) => <MenuMui elevation={2} {...props} />)(() => ({
  '& .MuiPaper-root': {
    marginTop: 8,
    backgroundColor: '#FFF'
  }
}));

export const MenuItem = styled(MenuItemMui)({
  color: '#565F6F',
  '& .MuiSvgIcon-root': {
    marginRight: 8,
    color: '#0675DD'
  }
});

export const ConsentNeeded = styled('button')({
  marginLeft: 24,
  color: '#E31B0C',
  textDecoration: 'underline',
  cursor: 'pointer',
  border: 'none',
  background: 'none',
  padding: 0,
  fontWeight: 600,
  fontSize: 12,
  '&:focus': {
    outline: 'none'
  }
});

export const ConsentGiven = styled('div')({
  marginLeft: 24,
  fontWeight: 600,
  color: '#008A06',
  padding: 0,
  fontSize: 12,
  textDecoration: 'underline'
});

export const NotSubmitted = styled('div')({
  display: 'inline-block',
  borderRadius: 4,
  color: '#FFF',
  fontSize: 12,
  lineHeight: '19px',
  fontWeight: 500,
  background: '#ADADAD',
  padding: '0px 4px',
  minWidth: 80,
  textAlign: 'center'
});

export const Completed = styled(({ children, ...props }: any) => (
  <div {...props}>
    <CheckIcon />
    {children}
  </div>
))({
  textAlign: 'center',
  minWidth: 80,
  display: 'inline-block',
  whiteSpace: 'nowrap',
  borderRadius: 4,
  color: '#FFF',
  fontSize: 12,
  lineHeight: '19px',
  fontWeight: 500,
  background: '#008A06',
  padding: '0px 4px',
  svg: {
    width: 12,
    height: 12,
    marginRight: 4,
    marginBottom: -2
  }
});
